import axios from 'axios';
import {
  StockChangeReason,
  StockKind,
  StockLine,
  Warehouse,
} from '../models/StockLine';
import { StockLog } from '../models/StockLog';
import { SaleableProductModel } from '../../b2b-orders';

interface ListStockRequest {
  kind?: StockKind;
  warehouse?: Warehouse;
  product?: number;
  categories?: Array<string>;
}

const STOCK_URL = `${process.env.REACT_APP_API_URL}/api/stock/`;
const STOCK_LOGS_URL = `${process.env.REACT_APP_API_URL}/api/stock-logs/`;

function buildStockParams({
  kind,
  warehouse,
  product,
  categories,
}: ListStockRequest): URLSearchParams {
  const params = new URLSearchParams();
  if (kind) {
    params.append('kind', kind);
  }
  if (warehouse) {
    params.append('warehouse', String(warehouse));
  }
  if (product) {
    params.append('product', String(product));
  }
  (categories || []).forEach((category) => params.append('category', category));
  return params;
}

export async function listStock(request: ListStockRequest): Promise<{
  data: Array<StockLine>;
}> {
  return axios.get(STOCK_URL, { params: buildStockParams(request) });
}

export async function removeStock(id: number): Promise<void> {
  const ENDPOINT = `${STOCK_URL}${id}/`;
  return axios.delete(ENDPOINT);
}

export interface StockLineCreationRequest {
  kind: StockKind;
  quantity: number;
  warehouse: Warehouse;
  product: number;
  reason: StockChangeReason;
}
export async function createStock(
  stockLine: StockLineCreationRequest
): Promise<StockLine> {
  const ENDPOINT = STOCK_URL;
  return axios.post(ENDPOINT, stockLine);
}

export interface StockLineUpdateRequest {
  id: number;
  kind?: StockKind;
  quantity?: number;
  warehouse?: Warehouse;
  product?: number;
  reason?: StockChangeReason;
}
export async function updateStock(
  stockLine: StockLineUpdateRequest
): Promise<StockLine> {
  const ENDPOINT = `${STOCK_URL}${stockLine.id}/`;
  return axios.put(ENDPOINT, stockLine);
}

export async function listStockLogs({ kind, warehouse, product }): Promise<{
  data: Array<StockLog>;
}> {
  const params = {
    kind,
    warehouse,
    product,
  };

  const url = new window.URL(STOCK_LOGS_URL);
  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined) {
      url.searchParams.append(key, params[key]);
    }
  });

  return axios.get(url.toString());
}

export async function listProductVariants(): Promise<{
  data: Array<SaleableProductModel>;
}> {
  const ENDPOINT = `${process.env.REACT_APP_API_URL}/api/products-variants/`;
  return axios.get(ENDPOINT);
}

export async function downloadStockExcel(
  request: ListStockRequest
): Promise<Blob> {
  const response = await axios.get(`${STOCK_URL}download-excel/`, {
    params: buildStockParams(request),
    responseType: 'blob',
  });

  return response.data;
}
